<template>
    <div class="width-text-input">
        <b-table hover ref="SumCodTable" :items="items" :fields="fields" responsive show-empty>
            <template slot="sumDescription" slot-scope="row">
                {{ row.item.sumDescription }}
            </template>
            <template v-for="(keyList , index) in KeyTables"  :slot="keyList" slot-scope="row">
        
                 {{ (index === 0) ? row.item.key[keyList] : formatNumber(row.item.key[keyList]) }}
            </template>
        </b-table>
    </div>
    </template>
    
    <script>
    export default {
        props: {
            items: Array,
            fields: Array,
            KeyTables: Array,
        },
        methods: {
            formatNumber (num) {
                return `${this.$options.filters.numFormat(num,'0,0.00')}`;
            },
        },
    }
    </script>
    